import { Link, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import {
    Wallet,
    FileText,
    User as UserIcon,
    MessageSquare,
    LogOut
} from "lucide-react";
import { Link as LinkIcon } from "lucide-react";
import { PageProps } from "@/types";

interface User {
    id: number;
    name: string;
    email: string;
    role: string;
    sent_to_accountant_at: string | null;
    has_access: boolean;
}

interface MobileNavigationProps {
    user: User | null;
    expanded: boolean;
}

export default function MobileNavigation({ user, expanded }: MobileNavigationProps) {
    const { t } = useTranslation();
    const { auth } = usePage<PageProps>().props;

    if (!expanded) return null;

    return (
        <nav className="lg:hidden">
            <div className="mx-4 mt-4 bg-white/90 dark:bg-gray-800/90 backdrop-blur-md rounded-2xl shadow-xl border border-white/20 overflow-hidden">
                <div className="px-6 py-6">
                    <div className="grid gap-y-4">
                        {user ? (
                            <>
                                {/* Connect Accounts */}
                                <Link
                                    href={route("connect-accounts")}
                                    className="flex items-center p-4 text-base font-medium text-gray-700 dark:text-gray-200 transition-all duration-200 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-[#52E747] focus:ring-offset-2"
                                >
                                    <LinkIcon className="h-5 w-5 mr-3" />
                                    Conectar Carteiras
                                </Link>

                                {/* Portfolio */}
                                <Link
                                    href={route("portfolio.index")}
                                    className="flex items-center p-4 text-base font-medium text-gray-700 dark:text-gray-200 transition-all duration-200 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-[#52E747] focus:ring-offset-2"
                                >
                                    <Wallet className="h-5 w-5 mr-3" />
                                    Portfolio
                                </Link>

                                {/* Reports - disabled if not sent to accountant and not admin */}
                                {/* <div className="relative group">
                                    <Link
                                        href={route("waiting-for-accountant")}
                                        className={`flex items-center p-4 text-base font-medium transition-all duration-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#52E747] focus:ring-offset-2 ${
                                            user.sent_to_accountant_at === null && auth.user?.role !== "admin"
                                                ? "text-red-500 dark:text-red-400 cursor-not-allowed opacity-50 pointer-events-none"
                                                : "text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                                        }`}
                                    >
                                        <FileText className="h-5 w-5 mr-3" />
                                        Relatórios
                                    </Link>

                                    {user.sent_to_accountant_at === null && auth.user?.role !== "admin" && (
                                        <div className="mt-2 p-3 text-xs text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 rounded-lg">
                                            Você deve conectar pelo menos uma carteira de criptomoedas ou conta de exchange e enviá-las aos nossos contadores para que possam analisar suas transações para fins fiscais.
                                        </div>
                                    )}
                                </div> */}

                                {/* My Account */}
                                <Link
                                    href={route("profile.edit")}
                                    className="flex items-center p-4 text-base font-medium text-gray-700 dark:text-gray-200 transition-all duration-200 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-[#52E747] focus:ring-offset-2"
                                >
                                    <UserIcon className="h-5 w-5 mr-3" />
                                    Minha Conta
                                </Link>

                                {/* Support */}
                                <a
                                    href="https://wa.me/5511913341649"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center p-4 text-base font-medium text-gray-700 dark:text-gray-200 transition-all duration-200 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-[#52E747] focus:ring-offset-2"
                                >
                                    <MessageSquare className="h-5 w-5 mr-3" />
                                    Suporte
                                </a>

                                {/* Logout */}
                                <Link
                                    href={route("logout")}
                                    method="post"
                                    as="button"
                                    className="flex items-center p-4 text-base font-medium text-red-600 dark:text-red-400 transition-all duration-200 rounded-xl hover:bg-red-50 dark:hover:bg-red-900/20 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                                >
                                    <LogOut className="h-5 w-5 mr-3" />
                                    Sair
                                </Link>
                            </>
                        ) : (
                            <>
                                {/* Login */}
                                <Link
                                    href="/login"
                                    className="flex items-center justify-center p-4 text-base font-medium text-gray-700 dark:text-gray-200 transition-all duration-200 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-[#52E747] focus:ring-offset-2"
                                >
                                    {t("login")}
                                </Link>
                                
                                {/* Register */}
                                <Link
                                    href="/register"
                                    className="inline-flex items-center justify-center px-6 py-4 text-base font-bold leading-7 text-white transition-all duration-200 bg-[#52E747] hover:bg-[#3fd438] border border-transparent rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#52E747] shadow-lg"
                                    role="button"
                                >
                                    {t("register")}
                                </Link>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
}